import { render, staticRenderFns } from "./ResultsStats.vue?vue&type=template&id=7baa8d11&"
import script from "./ResultsStats.vue?vue&type=script&lang=js&"
export * from "./ResultsStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports